<mat-form-field [class]="inputClass">

  <mat-label>{{label}}</mat-label>

  <input #searchInput
    matInput
    [errorStateMatcher]="errorStateMatcher"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    type="text"
    (input)="onInput($event.target.value)"
    (blur)="onTouched()">

    <mat-autocomplete #auto="matAutocomplete"
      (optionSelected)="onSelect($event.option.value)"
      [displayWith]="displayFn">

      @if (filteredOptions) {
        @for (country of filteredOptions; track country) {
          <mat-option [value]="country">
            {{ showCallingCode ? country.countryWithCode : country.name }}
          </mat-option>
        }
        @if (searchInput.value.length >= minSearchLength && !filteredOptions.length) {
          <mat-option [disabled]="true">
            No results found
          </mat-option>
        }
      }

    </mat-autocomplete>

    <div matSuffix>
      <ng-container [appPreloader]="[endpoints.COUNTRIES_GET]"
        [preloaderType]="preloaderTypes.ICON"
        [preloaderSize]="20">
      </ng-container>
    </div>

    <!-- Show control errors -->
    <mat-error>
      <app-validation-error [errors]="ngControl.errors"></app-validation-error>
    </mat-error>
  </mat-form-field>
